import React, { useEffect, useRef, useState } from "react";
import { CaseDetail } from "../../../models/CaseDetail/caseDetail.model";
import AdminCaseService from "../../../services/Case/AdminCase/adminCase.service";
import SharedCaseService from "../../../services/Shared/shared.service";
import { CaseStatusEnum } from "../../../enums/caseStatus.enum";
import moment from "moment";
import {
  Badge,
  Button,
  Menu,
  Modal,
  Popconfirm,
  Popover,
  Table,
  TablePaginationConfig,
  Tooltip,
  Input,
  Select,
  Row,
  Col,
  Drawer,
} from "antd";
import AppLoader from "../../../shared/components/AppLoader";
import AppCard from "../../../shared/components/AppCard";
import {
  DownloadOutlined,
  UserAddOutlined,
  FormOutlined,
  CloudDownloadOutlined,
  EllipsisOutlined,
  CopyOutlined,
  EditOutlined,
  WhatsAppOutlined,
  ShareAltOutlined,
  CheckOutlined,
  HistoryOutlined,
  ScheduleOutlined,
  LockOutlined,
  CommentOutlined,
  QrcodeOutlined,
} from "@ant-design/icons";
import CaseAssignmentForm from "./CaseAssignmentForm";
import {
  copyCaseDetailsToClipboard,
  copyImageToClipboard,
  stopPropogateEvent,
} from "../../../shared/utils/eventUtils";
import CaseOverview from "../../../shared/components/CaseOverview";
import "./adminCases.scss";
import CaseFilterForm from "../../../shared/components/CaseFilterForm";
import { CaseFilterParams } from "../../../models/CaseFilterParams/caseFilterParams.model";
import { CaseBodyPart } from "../../../models/CaseBodyPart/caseBodyPart.model";
import { Admin } from "../../../models/Admin/admin.model";
import ProfileService from "../../../services/Profile/profile.service";
import { UserRoleEnum } from "../../../enums/userRole.enum";
import ReportService from "../../../services/Report/report.service";
import { DownloadFileTypeEnum } from "../../../enums/downloadFileType.enum";
import {
  formatStatus,
  getCustomCellStyles,
  getInitialFiltersFromURL,
  hexToRgba,
} from "../../../shared/utils/dataFormatConverter";
import { generatePath, Link, useHistory } from "react-router-dom";
import { AppRoutes } from "../../../routes/routeConstants/appRoutes";
import { buildCaseDetailViewerUrl } from "../../../shared/utils/caseViewerOpenUrl";
import { getCosignConfirm } from "../../../shared/utils/cosignConfirm";
import CaseContainer from "../../../store/container/CaseContainer";
import { CaseReducerProps } from "../../../store/reducers/caseReducer";
import ReportLockContainer from "../../../store/container/ReportLockContainer";
import { ReportLockReducerProps } from "../../../store/reducers/reportLockReducer";
import { useLocation } from "react-router-dom";
import Notification from "../../../shared/components/Notification";
import { NotificationTypes } from "../../../enums/notificationTypes";
import { AuthReducerProps } from "../../../store/reducers/authReducer";
import { PaginationMeta } from "../../../models/PaginationMeta/paginationMeta.model";
import { AdminFeatureEnum } from "../../../enums/AdminFeature.enum";
import { AdminTypeEnum } from "../../../enums/AdminType.enum";
import { TagEnum } from "../../../enums/tag.enum";
import CaseForm from "../ScanCenterCases/CaseForm";
import CaseSharing from "../../../shared/components/CaseSharing";
import ContextMenu from "../../../shared/components/ContextMenu";
import CaseChatDrawer from "../../../shared/components/CaseChatDrawer";
import { Tag } from "../../../models/Tag/tag.model";
import TagLegend from "../../../shared/components/TagLegend";
import ReportHistory from "../../../shared/components/ReportHistory";
import CaseTurnaroundTime from "../../../shared/components/CaseTurnaroundTime";
import AppSync from "../../../shared/components/AppSync";
import { deserialize } from "serializr";
import ReportForm from "../../../shared/components/ReportForm";
import CaseSeriesExpandRow from "../../../shared/components/CaseSeriesExpandRow";
import ListingColumnPreferenceService, {
  ListingColumnPreferencesResponse,
} from "../../../services/ListingColumnPreference/listingColumnPreference.service";
import {
  ACTIONS_COLUMN_MIN_WIDTH,
  ADMIN_CASES_LOCKED_COLUMN_ORDER,
  DEFAULT_ACTIONS_COLUMN_WIDTH,
  LISTING_CONTEXT,
  ListingColumnKey,
  minWidthForListingColumnKey,
} from "../../../constants/listingColumnKeys";
import { applyListingColumnPreferences } from "../../../utils/listingColumns/applyListingColumnPreferences";
import { mergeListingWidthsFromTable } from "../../../utils/listingColumns/mergeListingWidthsFromTable";
import {
  buildCaseChatUnreadCountsFromCases,
  getDisplayedCaseChatUnread,
} from "../../../shared/utils/caseChatUnread";
import { useHighlightCaseRowFromQuery } from "../../../shared/hooks/useHighlightCaseRowFromQuery";

const getReportedReports = (caseDetail: CaseDetail | undefined) =>
  caseDetail?.reports?.filter((r) => r.status === true) ?? [];

// ─────────────────────────────────────────────────────────────────────────────

interface AdminCasesProps extends CaseReducerProps, AuthReducerProps, ReportLockReducerProps {}

function AdminCases({
  createdCaseId,
  updatedCaseId,
  deletedCaseId,
  setNewCaseCreated,
  setCaseDetailUpdated,
  setCaseDeleted,
  adminType,
  user,
  userRole,
  eventId,
  lockEvent,
  lockEventReportId,
  lockEventLockedBy,
  lockEventForceReleased,
  caseChatUnreadCounts,
  mergeCaseChatUnread,
  setCaseChatDrawerCaseId,
}: AdminCasesProps) {
  const location = useLocation();

  const [caseDetails, setCaseDetails] = useState<CaseDetail[]>([]);

  const [paginationMeta, setPaginationMeta] = useState<PaginationMeta>(
    Object.assign(new PaginationMeta(), {
      currentPage: 1,
      totalCount: 0,
      totalPages: 0,
    })
  );

  const [activeCase, setActiveCase] = useState<CaseDetail | undefined>();

  const [loading, setLoading] = useState(false);

  const { rowClassName: caseListRowClassName } = useHighlightCaseRowFromQuery(
    caseDetails,
    loading
  );

  const [isSyncing, setSyncing] = useState(false);

  const [downloadLoading, setDownloadLoading] = useState(false);

  const [downloadZipLoading, setDownloadZipLoading] = useState(false);

  const [showCaseOverview, setShowCaseOverview] = useState(false);

  const [showReportHistory, setShowReportHistory] = useState(false);

  const [showReportForm, setShowReportForm] = useState(false);

  const [showTATModal, setShowTATModal] = useState(false);

  const [tatLoading, setTatLoading] = useState(false);

  const [tatData, setTatData] = useState<any>(null);

  const [showCaseForm, setShowCaseForm] = useState(false);

  const [me, setMe] = useState<Admin>();

  const assignmentPopoverRef = useRef<any>(null);

  const viewPopoverRef = useRef<any>(null);

  const [activePopoverId, setActivePopoverId] = useState<number | null>(null);

  const history = useHistory();

  const [menuVisible, setMenuVisible] = useState(false);

  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });

  const [caseChat, setCaseChat] = useState<{ id: number; title: string } | null>(
    null
  );

  const [selectedRow, setSelectedRow] = useState<any>(null);

  const menuRef = useRef<HTMLDivElement>(null);

  const [formValues, setFormValues] = useState<CaseFilterParams>(
    Object.assign(new CaseFilterParams(), {
      ...new CaseFilterParams(),
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      scanCenterBranchId: undefined,
    })
  );

  // report_id → locked_by display_name (populated via real-time socket events)
  const [lockedReports, setLockedReports] = useState<Record<number, { name: string }>>({});

  // Controls which case's assign Popover is programmatically opened (e.g. after force-unlock)
  const [assignPopoverOpenCaseId, setAssignPopoverOpenCaseId] = useState<number | null>(null); 

  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);

  const resizingColumnRef = useRef(null);

  const startXRef = useRef(0);

  const startWidthRef = useRef(0);

  // Cleanup on component unmount to clear the debounce timer
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuVisible(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  const handleToggleCaseForm = () =>
    setShowCaseForm((showCaseForm) => !showCaseForm);

  const handleToggleReportHistory = () => setShowReportHistory((showReportHistory) => !showReportHistory);

  const handleShowTAT = (caseDetail: CaseDetail) => {
    if (!caseDetail?.id) return;
    setActiveCase(caseDetail);
    setTatLoading(true);
    AdminCaseService.getCaseTAT(
      Number(caseDetail.id),
      (data: any) => {
        setTatData(data);
        setShowTATModal(true);
      },
      () => {},
      () => {
        setTatLoading(false);
      }
    );
  };

  const handleCloseCaseOverview = () => {
    setActiveCase(undefined);
    setShowCaseOverview(false);
  };

  const handleViewAccessSuccess = () => {
    if (viewPopoverRef?.current && viewPopoverRef.current) {
      viewPopoverRef.current.setPopupVisible(false);
    }
    setActiveCase(undefined);
  };

  const handleRowContextMenu = (
    record: CaseDetail,
    event: React.MouseEvent
  ) => {
    event.preventDefault();
    setSelectedRow(record);
    setMenuPosition({ x: event.pageX, y: event.pageY });
    setMenuVisible(true);
  };

  const handleSeriesOpen = (caseId: number, seriesIds: string[]) => {
    // Join raw folder paths with a comma — URLSearchParams.set (inside
    // buildCaseDetailViewerUrl) percent-encodes the value exactly once.
    // Encoding here would cause double-encoding and break the viewer fetch.
    const seriesCsv = seriesIds.length > 0 ? seriesIds.join(",") : undefined;
    window.open(
      buildCaseDetailViewerUrl(caseId, seriesCsv ? { seriesIdCsv: seriesCsv } : undefined),
      "_blank"
    );
  };

  const handleRowChange = (caseDetail: CaseDetail, _: number | undefined) => {
    return {
      onClick: (event: any) => {
        if (event.target.closest(".ant-table-row-expand-icon")) return;
        event.preventDefault();
        if (caseDetail?.id) {
          window.open(buildCaseDetailViewerUrl(caseDetail.id), "_blank");
        }
      },
      onContextMenu: (event: React.MouseEvent) =>
        handleRowContextMenu(caseDetail, event),
    };
  };

  const handlePageChange = (pagination: TablePaginationConfig) => {
    const values = Object.assign(new CaseFilterParams(), {
      ...formValues,
      page: pagination.current,
      perPage: pagination.pageSize,
    });
    updateUrlParams(values);
  };

  const handleResetFilters = () => {
    history.replace(location.pathname);
  };

  // Update URL with current filter values
  const updateUrlParams = (values: CaseFilterParams) => {
    const searchParams = new URLSearchParams();
    // Add non-empty filter values to URL
    Object.entries(values).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        searchParams.set(key, String(value));
      }
    });
    // Update URL without page reload
    history.replace(`${location.pathname}?${searchParams.toString()}`);
  };

  const handleFetchCases = (formValues: CaseFilterParams, isSyncing: boolean = false) => {
    if(isSyncing) {
      setSyncing(true);
    } else {
      setLoading(true);
    }
    AdminCaseService.fetchAdminCases(
      formValues,
      (caseDetails: CaseDetail[], paginationMeta: PaginationMeta) => {
        setCaseDetails(caseDetails);
        setPaginationMeta(paginationMeta);
        mergeCaseChatUnread(buildCaseChatUnreadCountsFromCases(caseDetails));
      },
      () => {},
      () => {
        if(isSyncing) {
          setSyncing(false);
        } else {
          setLoading(false);
        }
      }
    );
  };

  const handleToggleReportForm = () => setShowReportForm((prev) => !prev);

  const handleAssignmentSuccess = (caseDetail: CaseDetail) => {
    const caseIndex = caseDetails.findIndex(
      (caseItem) => caseItem.id === caseDetail.id
    );
    if (caseIndex >= 0) {
      caseDetails[caseIndex] = caseDetail;
    }
    setCaseDetails([...caseDetails]);
    if (assignmentPopoverRef?.current && assignmentPopoverRef.current) {
      assignmentPopoverRef.current.setPopupVisible(false);
    }
  };

  const handleCaseUpdateSuccess = (caseDetail: CaseDetail) => {
    const caseIndex = caseDetails.findIndex(
      (caseItem) => caseItem.id === caseDetail.id
    );
    if (caseIndex >= 0) {
      caseDetails[caseIndex] = caseDetail;
    }
    setCaseDetails([...caseDetails]);
    setActiveCase(caseDetail);
  };

  const handleDownloadReport = (
    caseDetail: CaseDetail,
    fileType: DownloadFileTypeEnum,
    withLetterHead: boolean,
    reportId?: number,
  ) => {
    setActiveCase(caseDetail);
    setDownloadLoading(true);
    if (caseDetail?.id) {
      const apiMethod = ReportService.downloadReport;
      apiMethod(
        fileType,
        caseDetail,
        withLetterHead,
        reportId ?? 0,
        (reportUrl: string) => {
          window.open(reportUrl, "_blank");
        },
        () => {},
        () => {
          setActiveCase(undefined);
          setDownloadLoading(false);
        }
      );
    }
  };

  const handleViewReport = (
      caseDetail: CaseDetail,
      reportId?: number,
  ) => {
    setActiveCase(caseDetail);
    setDownloadLoading(true);
    if (caseDetail?.id) {
      const apiMethod = ReportService.previewReport;
      apiMethod(
          caseDetail?.id,
          reportId ?? 0,
          (data: Blob) => {
            const fileURL = window.URL.createObjectURL(
                new Blob([data], { type: "application/pdf" })
            );
            const pdfWindow = window.open(fileURL, "_blank");
            if (pdfWindow) {
              pdfWindow.onload = () => {
                window.URL.revokeObjectURL(fileURL);
              };
            }
          },
          () => {},
          () => {
            setActiveCase(undefined);
            setDownloadLoading(false);
          }
      );
    }
  };

  const handleDownloadDirectReport = (
    caseDetail: CaseDetail | undefined,
    reportId?: number | undefined,
  ) => {
    if (caseDetail?.id) {
      ReportService.downloadDirectReport(
          caseDetail?.id,
          reportId ?? 0,
          (reportUrl: string) => {
            window.open(reportUrl, "_blank");
          },
          () => {},
          () => {
          }
      );
    }
  };

  const handleDownloadDetails = (caseDetail: CaseDetail) => {
      setActiveCase(caseDetail);

      if (!caseDetail?.id) return;

      setDownloadZipLoading(true);

      let pollInterval: NodeJS.Timeout | null = null;

      const stopPolling = () => {
          if (pollInterval) {
              clearInterval(pollInterval);
              pollInterval = null;
          }
          setDownloadZipLoading(false);
      };

      const openZipIfAvailable = (response: any) => {
          if (response?.url) {
              window.open(response.url, "_blank");
              stopPolling();
              return true;
          }
          return false;
      };

      // -----------------------------
      // Initial request
      // -----------------------------
      AdminCaseService.downloadAdminCase(
          Number(caseDetail.id),
          (response: any) => {
              Notification({
                  message: "Zip file is getting ready for download",
                  type: NotificationTypes.SUCCESS,
              });
              // If URL already exists → open immediately
              if (openZipIfAvailable(response)) return;

              // -----------------------------
              // Start polling every 10 seconds
              // -----------------------------
              pollInterval = setInterval(() => {
                  AdminCaseService.downloadAdminZipCase(
                      Number(caseDetail.id),
                      (pollResponse: any) => {
                          openZipIfAvailable(pollResponse);
                          // setDownloadZipLoading(false);
                      },
                      () => {},
                      () => {}
                  );
              }, 10_000);
          },
          () => {},
          () => {}
      );
  };

  const handleCaseShareLink = (caseDetail: CaseDetail) => {
    setActiveCase(caseDetail);
    if (caseDetail?.id) {
      SharedCaseService.getCaseShareLink(
        Number(caseDetail?.id),
        (targetUrl: any) => {
          copyCaseDetailsToClipboard(caseDetail, targetUrl);
        },
        () => {},
        () => {}
      );
    }
  };

  // "Copy QR" variant of the share flow. Uses the same shareable-link backend
  // call but copies the PNG returned as `qr_code` directly onto the system
  // clipboard as an image, so the admin can paste it into chat apps / docs
  // and have the QR render. The backend generates the QR against the same
  // shareable URL as "Copy Sharing Link".
  const handleCaseShareQr = (caseDetail: CaseDetail) => {
    setActiveCase(caseDetail);
    if (!caseDetail?.id) return;
    SharedCaseService.getCaseShareLink(
      Number(caseDetail.id),
      async (_link: string, _token: string, qrCode: string) => {
        if (!qrCode) {
          Notification({
            message: "QR code unavailable for this case",
            type: NotificationTypes.ERROR,
          });
          return;
        }
        const ok = await copyImageToClipboard(qrCode);
        Notification({
          message: ok
            ? "QR copied — paste anywhere you need"
            : "Unable to copy QR to clipboard",
          type: ok ? NotificationTypes.SUCCESS : NotificationTypes.ERROR,
        });
      },
      () => {},
      () => {}
    );
  };

  // Initial data fetch with URL parameters
  useEffect(() => {
    const initialFilters = getInitialFiltersFromURL(location.search);
    setFormValues(initialFilters);
    handleFetchCases(initialFilters);
  }, [location.search]); // Re-fetch when URL changes

  useEffect(() => {
    // ProfileService.getProfile(
    //   UserRoleEnum.ADMIN,
    //   (admin: Admin) => {
    //     setMe(admin);
    //   },
    //   () => {},
    //   () => {}
    // );
    if(user && userRole === UserRoleEnum.ADMIN) {
      setMe(user as Admin);
    }
  }, [user, userRole]);

  useEffect(() => {
    if (createdCaseId) {
      // AdminCaseService.showAdminCase(createdCaseId, (caseDetail: CaseDetail) => {
      //   const caseIndex = caseDetails.findIndex(caseItem => caseItem.id === caseDetail.id);
      //   if (caseIndex >= 0) {
      //     caseDetails[caseIndex] = caseDetail;
      //   } else {
      //     caseDetails.unshift(caseDetail);
      //   }
      //   setCaseDetails([...caseDetails]);
      //   setNewCaseCreated(null);
      // }, () => {}, () => {});
      handleFetchCases(formValues, true);
      setNewCaseCreated(null);
    }
  }, [createdCaseId, setNewCaseCreated]);

  useEffect(() => {
    if (updatedCaseId) {
      // AdminCaseService.showAdminCase(updatedCaseId, (caseDetail: CaseDetail) => {
      //   const caseIndex = caseDetails.findIndex(caseItem => caseItem.id === caseDetail.id);
      //   if (caseIndex >= 0) {
      //     caseDetails[caseIndex] = caseDetail;
      //   } else {
      //     caseDetails.unshift(caseDetail);
      //   }
      //   setCaseDetails([...caseDetails]);
      //   setCaseDetailUpdated(null);
      // }, () => {}, () => {});
      handleFetchCases(formValues, true);
      setCaseDetailUpdated(null);
    }
  }, [updatedCaseId, setCaseDetailUpdated]);

  useEffect(() => {
    if (deletedCaseId) {
      // AdminCaseService.showAdminCase(deletedCaseId, (caseDetail: CaseDetail) => {
      //   const caseIndex = caseDetails.findIndex(caseItem => caseItem.id === caseDetail.id);
      //   if (caseIndex >= 0) {
      //     caseDetails.splice(caseIndex, 1);
      //   }
      //   setCaseDetails([...caseDetails]);
      //   setCaseDeleted(null);
      // }, () => {}, () => {});
      handleFetchCases(formValues, true);
      setCaseDeleted(null);
    }
  }, [deletedCaseId, setCaseDeleted]);

  // Track report lock events so the listing can show the lock icon in real-time
  useEffect(() => {
    if (!lockEvent || !lockEventReportId) return;
    const isReportLockEnabled = (user?.adminFeatures ?? []).some(
      (f: any) => f.feature === AdminFeatureEnum.REPORT_LOCK
    );
    if (!isReportLockEnabled) return;
    if (lockEvent === "acquired" && lockEventLockedBy) {
      setLockedReports((prev) => ({
        ...prev,
        [lockEventReportId]: { name: lockEventLockedBy.display_name },
      }));
    }
    if (lockEvent === "released") {
      setLockedReports((prev) => {
        const next = { ...prev };
        delete next[lockEventReportId];
        return next;
      });
    }
  }, [eventId]);

  // Derive lock state from the top-level `lock` object embedded in each case by the API
  useEffect(() => {
    const isReportLockEnabled = (user?.adminFeatures ?? []).some(
      (f: any) => f.feature === AdminFeatureEnum.REPORT_LOCK
    );
    if (!isReportLockEnabled) return;

    const snapshot: Record<number, { name: string }> = {};
    caseDetails.forEach((c) => {
      // lock is per-case; find the active draft report to get its ID for the key
      const draftReport = c.reports?.find((r) => !r.status);
      if (draftReport?.id && c.lock?.locked && c.lock?.locked_by) {
        snapshot[draftReport.id] = { name: c.lock.locked_by.display_name };
      }
    });
    setLockedReports(snapshot);
  }, [caseDetails, user]);

  const handleForceReleaseLock = (reportId: number) => {
    ReportService.forceReleaseReportLock(
      reportId,
      () => {
        setLockedReports((prev) => {
          const next = { ...prev };
          delete next[reportId];
          return next;
        });
        Notification({ message: "Lock force-released", type: NotificationTypes.SUCCESS });
      },
      () => {
        Notification({ message: "Failed to force-release lock", type: NotificationTypes.ERROR });
      },
      () => {}
    );
  };

  const handleEditCase = (caseDetail: CaseDetail) => () => {
    setActiveCase(caseDetail);
    handleToggleCaseForm();
  };

  const handleUploadCaseSuccess = (caseDetail: CaseDetail) => {
    const caseIndex = caseDetails.findIndex(
      (caseItem) => caseItem.id === caseDetail.id
    );
    if (caseIndex >= 0) {
      caseDetails[caseIndex] = caseDetail;
    } else {
      caseDetails.unshift(caseDetail);
    }
    setCaseDetails([...caseDetails]);
  };

  const handleUpdateTags = (caseId: number, tags: Tag[]) => {
    const caseIndex = caseDetails.findIndex(
      (caseItem) => caseItem.id === caseId
    );
    if (caseIndex >= 0) {
      caseDetails[caseIndex].tags = tags;
    }
    setCaseDetails([...caseDetails]);
  };

  const [columns, setColumns] = useState<any>([]);

  const [listingPrefsApi, setListingPrefsApi] = useState<
    ListingColumnPreferencesResponse | null | undefined
  >(undefined);

  const columnsRef = useRef<any[]>([]);
  const listingPrefsRef = useRef(listingPrefsApi);
  useEffect(() => {
    columnsRef.current = columns;
  }, [columns]);
  useEffect(() => {
    listingPrefsRef.current = listingPrefsApi;
  }, [listingPrefsApi]);

  const handleMouseDown = (e: any, index: any) => {
    resizingColumnRef.current = index;
    startXRef.current = e.clientX;
    startWidthRef.current = columns[index].width;

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e: any) => {
    if (resizingColumnRef.current !== null) {
      const idx = resizingColumnRef.current;
      const newWidth = startWidthRef.current + (e.clientX - startXRef.current);
      const newColumns = [...columns];
      const key = newColumns[idx]?.listingColumnKey;
      const minW = minWidthForListingColumnKey(key, ACTIONS_COLUMN_MIN_WIDTH);
      newColumns[idx].width = Math.max(newWidth, minW);
      columnsRef.current = newColumns;
      setColumns(newColumns);
    }
  };

  const handleMouseUp = () => {
    const idx = resizingColumnRef.current;
    resizingColumnRef.current = null;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
    if (idx === null) return;
    const prefs = listingPrefsRef.current;
    const cols = columnsRef.current;
    if (!prefs?.columns?.length) return;
    const endW = cols[idx]?.width;
    if (endW === undefined) return;
    if (Math.round(Number(startWidthRef.current)) === Math.round(Number(endW))) return;
    const rows = mergeListingWidthsFromTable(cols, prefs.columns);
    ListingColumnPreferenceService.save(
      UserRoleEnum.ADMIN,
      LISTING_CONTEXT.ADMIN_CASES,
      rows,
      (res) => {
        setListingPrefsApi((prev) =>
          prev && res.columns ? { ...prev, columns: res.columns } : prev
        );
      },
      () => {},
      () => {}
    );
  };

  useEffect(() => {
    if (!me?.id) return;
    ListingColumnPreferenceService.fetch(
      UserRoleEnum.ADMIN,
      LISTING_CONTEXT.ADMIN_CASES,
      (data) => setListingPrefsApi(data),
      () => setListingPrefsApi(null),
      () => {}
    );
  }, [me?.id]);

  useEffect(() => {
    if (!me || listingPrefsApi === undefined) return;

    const screenWidth = window.innerWidth;
    const adminFeatures = me?.adminFeatures?.map(
      (adminFeature) => adminFeature.feature
    );

    const hasReportLock = adminFeatures?.includes(AdminFeatureEnum.REPORT_LOCK);

    const hasDefaultFullScreen = adminFeatures?.includes(AdminFeatureEnum.REPORT_EDIT_FULL_SCREEN_DEFAULT);

    const isCosignEnabled = adminFeatures?.includes(AdminFeatureEnum.COSIGN) ?? false;

    const defs: Record<string, any> = {};

    defs[ListingColumnKey.TAGS] = {
        listingColumnKey: ListingColumnKey.TAGS,
        title: "Tags",
        dataIndex: "id",
        key: "id",
        width: 50,
        ellipsis: true,
        fixed: screenWidth > 900 ? "left" : undefined,
        render: (_: number, caseDetail: CaseDetail) => (
          <div className="admin-cases__tags">
            {caseDetail?.tags?.filter((tag) => tag?.name?.toLowerCase() !== TagEnum.CASE_OPENED).map((tag) => {
              const isInteresting = tag?.name?.toLowerCase() === TagEnum.INTERESTING;
              const tooltipTitle = isInteresting && tag?.keyword
                ? `${tag.formattedName}: ${tag.keyword}`
                : tag.formattedName;
              return (
                <Tooltip title={tooltipTitle} key={tag.id}>
                  <span
                    className="admin-cases__tag-item"
                    style={{ backgroundColor: tag.color }}
                  />
                </Tooltip>
              );
            })}
          </div>
        ),
        onCell: (caseDetail: CaseDetail) => {
          const caseOpenedTag = caseDetail?.tags?.find(
            (tag) => tag?.name?.toLowerCase() === TagEnum.CASE_OPENED
          );
          return caseOpenedTag
            ? { className: "admin-cases__tag-cell--case-opened", style: { "--case-opened-bg": hexToRgba(caseOpenedTag.color ?? "#000000", 1) } as React.CSSProperties }
            : {};
        },
      };

    defs[ListingColumnKey.PATIENT_ID] = {
        listingColumnKey: ListingColumnKey.PATIENT_ID,
        title: "Patient ID",
        dataIndex: "patientId",
        key: "patientId",
        width: 100,
        ellipsis: true,
        render: (patientId: string, caseDetail: CaseDetail) => (
          <div
            className="admin-cases__patient-id"
            style={{ display: "flex", alignItems: "center" }}
          >
            {patientId}
            {/* {caseDetail.isUrgent && (
              <span
                style={{
                  width: 9,
                  height: 9,
                  backgroundColor: "red",
                  borderRadius: "50%",
                  marginLeft: 6,
                  animation: "blink 2s infinite",
                }}
              />
            )} */}
          </div>
        ),
        fixed: screenWidth > 900 ? "left" : undefined,
        onCell: getCustomCellStyles(100),
      };

    defs[ListingColumnKey.PATIENT_NAME] = {
        listingColumnKey: ListingColumnKey.PATIENT_NAME,
        title: "Patient Name",
        dataIndex: "patientName",
        key: "patientName",
        fixed: screenWidth > 900 ? "left" : undefined,
        width: 150,
        ellipsis: true,
        onCell: getCustomCellStyles(150),
      };

    defs[ListingColumnKey.PATIENT_AGE] = {
        listingColumnKey: ListingColumnKey.PATIENT_AGE,
        title: "Age",
        dataIndex: "age",
        key: "age",
        width: 80,
        ellipsis: true,
        onCell: getCustomCellStyles(80),
      };

    defs[ListingColumnKey.PATIENT_GENDER] = {
        listingColumnKey: ListingColumnKey.PATIENT_GENDER,
        title: "Gender",
        dataIndex: "gender",
        key: "gender",
        width: 90,
        ellipsis: true,
        onCell: getCustomCellStyles(90),
      };

    defs[ListingColumnKey.STUDY] = {
        listingColumnKey: ListingColumnKey.STUDY,
        title: "Study",
        dataIndex: "scanTypeName",
        key: "scanTypeName",
        render: (_: string, record: CaseDetail) => (
          <span>{record?.getStudyName()}</span>
        ),
        width: 120,
        ellipsis: true,
        onCell: getCustomCellStyles(120),
      };

    defs[ListingColumnKey.REFERRING_DOCTOR] = {
        listingColumnKey: ListingColumnKey.REFERRING_DOCTOR,
        title: "Referring Doctor",
        dataIndex: "referringDoctor",
        key: "referringDoctor",
        render: (text: string) => (
          <span className="admin-cases__referring-doctor">
            {text || "-"}
          </span>
        ),
        width: 150,
        ellipsis: true,
        onCell: getCustomCellStyles(150),
      };

    if (
      adminFeatures &&
      adminFeatures?.includes(AdminFeatureEnum.SHOW_PATIENT_HISTORY)
    ) {
      defs[ListingColumnKey.PATIENT_HISTORY] = {
              listingColumnKey: ListingColumnKey.PATIENT_HISTORY,
              title: "Patient History",
              dataIndex: "parsedPatientHistory",
              key: "parsedPatientHistory",
              width: 150,
              ellipsis: true,
              onCell: getCustomCellStyles(150),
            };
    }

    defs[ListingColumnKey.SCAN_CENTER] = {
        listingColumnKey: ListingColumnKey.SCAN_CENTER,
        title: "Scan Center",
        dataIndex: "scanCenterName",
        key: "scanCenterName",
        ellipsis: true,
        width: 120,
        onCell: getCustomCellStyles(120),
      };

    if (
      adminFeatures &&
      adminFeatures?.includes(AdminFeatureEnum.ACQUISITION_DATE)
    ) {
      defs[ListingColumnKey.STUDY_DATE] = {
        listingColumnKey: ListingColumnKey.STUDY_DATE,
        title: "Study Date",
        dataIndex: "studyDate",
        key: "studyDate",
        sorter: (a: any, b: any) => {
          const dateA = a.acquisitionDate || "";
          const dateB = b.acquisitionDate || "";
          return dateA.localeCompare(dateB);
        },
        ellipsis: true,
        render: (_: string, record: any) => {
          const date = record.acquisitionDate;
          return (
            <span>
              {date ? (
                <span>
                  {moment(date).format("DD-MMM-YY")}{" "}
                  {moment(date).format("hh:mm A")}
                </span>
              ) : (
                "-"
              )}
            </span>
          );
        },
        width: 150,
        onCell: getCustomCellStyles(150),
      };
    }

    defs[ListingColumnKey.UPLOADED_DATE] = {
        listingColumnKey: ListingColumnKey.UPLOADED_DATE,
        title: "Uploaded Date",
        dataIndex: "uploadedDate",
        key: "uploadedDate",
        sorter: (a: any, b: any) => {
          const dateA = a.createdAt || "";
          const dateB = b.createdAt || "";
          return dateA.localeCompare(dateB);
        },
        ellipsis: true,
        render: (_: string, record: any) => {
          const date = record.createdAt || "";
          return (
            <span>
              {date ? (
                <span>
                  {moment(date).format("DD-MMM-YY")}{" "}
                  {moment(date).format("hh:mm A")}
                </span>
              ) : (
                "NA"
              )}
            </span>
          );
        },
        width: 150,
        onCell: getCustomCellStyles(150),
      };

    defs[ListingColumnKey.ASSIGNED_DOCTOR] = {
        listingColumnKey: ListingColumnKey.ASSIGNED_DOCTOR,
        title: "Assigned Doctor",
        dataIndex: "assignedToDoctorName",
        key: "assignedToDoctorName",
        ellipsis: true,
        render: (doctorName: string) => (
          <span className="admin-cases__assigned-doctor">
            {doctorName || "NA"}
          </span>
        ),
        width: 130,
        onCell: getCustomCellStyles(130),
      };

    defs[ListingColumnKey.TIME_ELAPSED] = {
        listingColumnKey: ListingColumnKey.TIME_ELAPSED,
        title: "Time Elapsed",
        dataIndex: "timeElapsed",
        key: "timeElapsed",
        ellipsis: true,
        width: 120,
        onCell: getCustomCellStyles(120),
      };

    defs[ListingColumnKey.TAT] = {
        listingColumnKey: ListingColumnKey.TAT,
        title: "TAT",
        dataIndex: "tat",
        key: "tat",
        ellipsis: true,
        width: 100,
        onCell: getCustomCellStyles(100),
      };

    if (
      adminFeatures &&
      adminFeatures?.includes(AdminFeatureEnum.SHOW_REPORTED_TIME)
    ) {
      defs[ListingColumnKey.REPORTED_TIME] = {
              listingColumnKey: ListingColumnKey.REPORTED_TIME,
              title: "Reported Time",
              dataIndex: "reportedTime",
              key: "reportedTime",
              ellipsis: true,
              render: (date: string) => (
                <span>
                  {date ? (
                    <span>
                      {moment(date).format("DD-MMM-YY")}{" "}
                      {moment(date).format("hh:mm A")}
                    </span>
                  ) : (
                    "NA"
                  )}
                </span>
              ),
              width: 150,
              onCell: getCustomCellStyles(150),
            };
    }

    defs[ListingColumnKey.STATUS] = {
        listingColumnKey: ListingColumnKey.STATUS,
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: 100,
        onCell: () => ({
          className: "admin-cases__status-td",
          style: { minWidth: 100, maxWidth: 120 },
        }),
        sorter: (a: any, b: any) => a.status.localeCompare(b.status),
        render: (status: string, caseDetail: CaseDetail) => {
          const draftReport = caseDetail.reports?.find((r) => r.status === false);
          const hasDraftReport = status === CaseStatusEnum.ASSIGNED && !!draftReport;
          const lockInfo = draftReport?.id ? lockedReports[draftReport.id] : undefined;
          return (
            <div
              className="admin-cases__status-wrapper"
              onClick={stopPropogateEvent}
            >
              <span className={`admin-cases__status ${status}`}>
                {formatStatus(status)}
              </span>
              {hasDraftReport && (
                <Tooltip title="Report drafted — not yet submitted">
                  <FormOutlined className="admin-cases__draft-icon" />
                </Tooltip>
              )}
              {hasDraftReport && lockInfo && hasReportLock && (
                <Popover
                  content={
                    <div>
                      <Button
                        size="small"
                        danger
                        onClick={(e) => {
                          e.stopPropagation();
                          handleForceReleaseLock(draftReport!.id!);
                        }}
                      >
                        Force unlock
                      </Button>
                    </div>
                  }
                  title={<span>Locked by <strong>{lockInfo.name}</strong></span>}
                  trigger="hover"
                  overlayStyle={{ maxWidth: 220 }}
                >
                  <LockOutlined
                    style={{ color: "#f5222d", marginLeft: 4, cursor: "pointer" }}
                  />
                </Popover>
              )}
            </div>
          );
        },
      };

    defs[ListingColumnKey.ACTIONS] = {
        listingColumnKey: ListingColumnKey.ACTIONS,
        title: "Actions", 
        dataIndex: "id",
        key: "id",
        width: DEFAULT_ACTIONS_COLUMN_WIDTH,
        render: (_: string, caseDetail: CaseDetail) => {
          const showGenerateReport =
            (isCosignEnabled && caseDetail?.status !== CaseStatusEnum.REPORTED) ||
            caseDetail?.status === CaseStatusEnum.TO_BE_APPROVED ||
            (caseDetail?.status === CaseStatusEnum.ASSIGNED &&
              me?.id === caseDetail?.assignedToAdminId);
          // Generate Report auto-assigns the case to the current admin via
          // cosign_assign whenever the cosign rule is taking the case from
          // someone else (or assigning a previously-unowned case). The
          // helper returns a state-aware message + null when no popup is
          // needed (case is mine, REPORTED, or TO_BE_APPROVED-as-admin).
          const cosignConfirm = getCosignConfirm({
            caseDetail,
            userRole: UserRoleEnum.ADMIN,
            userId: me?.id,
            isCosignEnabled
          });
          const openGenerateReport = () => {
            if (hasDefaultFullScreen) {
              const path = generatePath(AppRoutes.GENERATE_REPORT, {
                caseId: String(caseDetail.id),
              });
              const returnSearch = location.search
                ? `?returnSearch=${encodeURIComponent(location.search.slice(1))}`
                : "";
              window.open(
                window.location.origin + path + returnSearch,
                "_blank"
              );
            } else {
              setActiveCase(caseDetail);
              setShowReportForm(true);
            }
          };
              const reportedReports = getReportedReports(caseDetail);
              const latestReport = reportedReports.length > 0
                ? reportedReports.reduce((a, b) => {
                    const aDate = a?.updatedAt ? new Date(a.updatedAt) : new Date(0);
                    const bDate = b?.updatedAt ? new Date(b.updatedAt) : new Date(0);
                    return aDate > bDate ? a : b;
                  })
                : undefined;
          const actionDraftReport = caseDetail.reports?.find((r) => r.status === false);
          const actionLockInfo = actionDraftReport?.id ? lockedReports[actionDraftReport.id] : undefined;
          const isAssignmentLocked = hasReportLock && !!actionLockInfo;
          const chatUnread = getDisplayedCaseChatUnread(
            caseDetail.id,
            caseDetail.unreadChatCount,
            caseChatUnreadCounts,
            caseChat?.id ?? null
          );
          return (
            <div onClick={stopPropogateEvent} className="case-list__row-actions">
              {caseDetail?.status !== CaseStatusEnum.VIEW && (
                isAssignmentLocked ? (
                  <Popconfirm
                    title={
                      <span>
                        Report is locked by <strong>{actionLockInfo!.name}</strong>.<br />
                        Force unlock to proceed with assignment?
                      </span>
                    }
                    okText="Force unlock & assign"
                    cancelText="Cancel"
                    placement="bottomLeft"
                    onConfirm={() => {
                      if (!actionDraftReport?.id) return;
                      ReportService.forceReleaseReportLock(
                        actionDraftReport.id,
                        () => {
                          setLockedReports((prev) => {
                            const next = { ...prev };
                            delete next[actionDraftReport.id!];
                            return next;
                          });
                          setAssignPopoverOpenCaseId(caseDetail.id ?? null);
                        },
                        () => {
                          Notification({ message: "Failed to force-release lock", type: NotificationTypes.ERROR });
                        },
                        () => {}
                      );
                    }}
                  >
                    <Tooltip title="Report is locked — click to force unlock and assign">
                      <Button icon={<UserAddOutlined />} />
                    </Tooltip>
                  </Popconfirm>
                ) : (
                  <Tooltip title="Assign Case">
                    <Popover
                      ref={assignmentPopoverRef}
                      visible={assignPopoverOpenCaseId === caseDetail.id || undefined}
                      onVisibleChange={(visible: boolean) => {
                        if (!visible && assignPopoverOpenCaseId === caseDetail.id) {
                          setAssignPopoverOpenCaseId(null);
                        }
                      }}
                      destroyTooltipOnHide
                      overlayClassName="admin-cases__assignment-popover"
                      placement="bottomLeft"
                      content={
                        <div>
                          <CaseAssignmentForm
                            caseDetail={caseDetail}
                            onSuccess={handleAssignmentSuccess}
                          />
                        </div>
                      }
                      title="Assign case"
                      trigger="click"
                    >
                      <Button icon={<UserAddOutlined />} />
                    </Popover>
                  </Tooltip>
                )
              )}
              {showGenerateReport && (
                <>
                  {cosignConfirm ? (
                    <Popconfirm
                      title={cosignConfirm.message}
                      okText={cosignConfirm.okText}
                      cancelText="Cancel"
                      placement="topRight"
                      onConfirm={openGenerateReport}
                    >
                      <Tooltip title="Generate Report">
                        <Button icon={<FormOutlined />} />
                      </Tooltip>
                    </Popconfirm>
                  ) : (
                    <Tooltip title="Generate Report">
                      <Button
                        icon={<FormOutlined />}
                        onClick={openGenerateReport}
                      />
                    </Tooltip>
                  )}
                </>
              )}
              {caseDetail?.status === CaseStatusEnum.REPORTED && (
                <Tooltip title="Download Latest Report">
                  <Popover
                    destroyTooltipOnHide
                    overlayClassName="admin-cases__assignment-popover"
                    placement="bottomLeft"
                    content={
                      <div>
                        <Menu mode="vertical" className="border-none">
                          {
                            latestReport?.directReportUpload ? 
                            (
                              <Menu.Item
                                className="navbar-item m-0"
                                key="view"
                                onClick={() => {
                                  handleDownloadDirectReport(
                                      caseDetail,
                                      latestReport?.id
                                  );
                                }}>
                                Download Report
                              </Menu.Item>
                            ): (
                              <>
                                <Menu.Item
                                  className="navbar-item m-0"
                                  key="view"
                                  onClick={() => {
                                    handleViewReport(
                                        caseDetail,
                                        latestReport?.id
                                    );
                                  }}
                                >
                                  View Report
                                </Menu.Item>
                                <Menu.Item
                                  className="navbar-item m-1"
                                  key="with_letterhead"
                                  onClick={() => {
                                    handleDownloadReport(
                                      caseDetail,
                                      DownloadFileTypeEnum.PDF,
                                      true,
                                      latestReport?.id
                                    );
                                  }}
                                >
                                  Download with Letterhead
                                </Menu.Item>
                                <Menu.Item
                                  className="navbar-item m-2"
                                  key="without_letterhead"
                                  onClick={() => {
                                    handleDownloadReport(
                                      caseDetail,
                                      DownloadFileTypeEnum.PDF,
                                      false,
                                      latestReport?.id
                                    );
                                  }}
                                >
                                  Download without Letterhead
                                </Menu.Item>
                                <Menu.Item
                                  className="navbar-item m-3"
                                  key="as_word"
                                  onClick={() => {
                                    handleDownloadReport(
                                      caseDetail,
                                      DownloadFileTypeEnum.WORD,
                                      false,
                                      latestReport?.id
                                    );
                                  }}
                                >
                                  Download as Word
                                </Menu.Item>
                              </>
                            )
                          }
                        </Menu>
                      </div>
                    }
                    title="Download Latest Report"
                    trigger="click"
                  >
                    <Button
                      loading={
                        activeCase?.id === caseDetail?.id && downloadLoading
                      }
                      icon={<DownloadOutlined />}
                    />
                  </Popover>
                </Tooltip>
              )}
              <Tooltip title="Download Case">
                <Button
                  loading={
                    activeCase?.id === caseDetail?.id && downloadZipLoading
                  }
                  icon={<CloudDownloadOutlined />}
                  onClick={() => {
                    handleDownloadDetails(caseDetail);
                  }}
                />
              </Tooltip>
              {adminFeatures?.includes(AdminFeatureEnum.DIGITAL_SHARING) &&
                !adminFeatures?.includes(AdminFeatureEnum.WHATSAPP_SHARING) && (
                  <>
                    <Tooltip title="Copy Link">
                      <Button
                        onClick={() => {
                          Notification({
                            message: "Copied",
                            type: NotificationTypes.SUCCESS,
                          });
                          handleCaseShareLink(caseDetail);
                        }}
                        icon={<CopyOutlined />}
                      />
                    </Tooltip>
                    <Tooltip title="Copy QR">
                      <Button
                        onClick={() => {
                          handleCaseShareQr(caseDetail);
                        }}
                        icon={<QrcodeOutlined />}
                      />
                    </Tooltip>
                  </>
                )}
              {adminFeatures?.includes(AdminFeatureEnum.DIGITAL_SHARING) &&
                adminFeatures?.includes(AdminFeatureEnum.WHATSAPP_SHARING) && (
                  <>
                    <Tooltip title="Share Link">
                      <Popover
                        destroyTooltipOnHide
                        overlayClassName="admin-cases__share-popover"
                        placement="bottomLeft"
                        content={
                          <div>
                            <Menu mode="vertical" className="border-none">
                              <Menu.Item
                                className="navbar-item m-0"
                                key="with_letterhead"
                                onClick={() => {
                                  Notification({
                                    message: "Copied",
                                    type: NotificationTypes.SUCCESS,
                                  });
                                  handleCaseShareLink(caseDetail);
                                }}
                              >
                                <CopyOutlined />
                                Copy Sharing Link
                              </Menu.Item>
                              <Menu.Item
                                className="navbar-item m-0"
                                key="copy_share_qr"
                                onClick={() => {
                                  handleCaseShareQr(caseDetail);
                                }}
                              >
                                <QrcodeOutlined />
                                Copy QR
                              </Menu.Item>
                            </Menu>
                            <div>
                              <CaseSharing caseDetail={caseDetail} />
                            </div>
                          </div>
                        }
                        title="Share Case Link"
                        trigger="click"
                      >
                        <Button icon={<ShareAltOutlined />} />
                      </Popover>
                    </Tooltip>
                  </>
                )}

              {reportedReports.length > 0 && (
                <Tooltip
                  title="Turnaround Time"
                  visible={showTATModal || tatLoading ? false : undefined}
                >
                  <Button
                    loading={activeCase?.id === caseDetail?.id && tatLoading}
                    icon={<ScheduleOutlined />}
                    onClick={() => {
                      handleShowTAT(caseDetail);
                    }}
                  />
                </Tooltip>
              )}
              {
                reportedReports.length > 0 &&
                  <Tooltip title="Report History">
                    <Button
                        icon={<HistoryOutlined />}
                        onClick={() => {
                          setActiveCase(caseDetail);
                          setShowReportHistory(true);
                        }}
                    />
                  </Tooltip>
              }
              {caseDetail?.status !== CaseStatusEnum.REPORTED && (
                <Tooltip title="Edit Case">
                  <Button
                    icon={<EditOutlined />}
                    onClick={handleEditCase(caseDetail)}
                  />
                </Tooltip>
              )}
              <Tooltip title="Case chat">
                <Badge
                  count={chatUnread}
                  size="small"
                  offset={[-2, 2]}
                  overflowCount={99}
                >
                  <Button
                    icon={<CommentOutlined />}
                    onClick={() => {
                      setCaseChatDrawerCaseId(caseDetail.id!);
                      setCaseChat({
                        id: caseDetail.id!,
                        title:
                          caseDetail.patientName ||
                          caseDetail.patientId ||
                          `Case #${caseDetail.id}`,
                      });
                    }}
                  />
                </Badge>
              </Tooltip>
              <Tooltip title="More Case Details">
                <Button
                  icon={<EllipsisOutlined />}
                  onClick={(event: any) => {
                    setActiveCase(caseDetail);
                    setShowCaseOverview(true);
                  }}
                />
              </Tooltip>
            </div>
          );
        },
        onCell: () => ({ className: "admin-cases__actions-cell" }),
      };

    const fallbackOrder =
      listingPrefsApi?.eligible_column_keys?.filter((k) => defs[k])?.length
        ? listingPrefsApi!.eligible_column_keys.filter((k) => defs[k])
        : Object.keys(defs);

    setColumns(
      applyListingColumnPreferences(defs, listingPrefsApi?.columns ?? null, fallbackOrder, {
        lockedLeadingKeys: ADMIN_CASES_LOCKED_COLUMN_ORDER,
      })
    );
  }, [me, adminType, caseDetails, caseChat, caseChatUnreadCounts, downloadZipLoading, downloadLoading, tatLoading, lockedReports, assignPopoverOpenCaseId, listingPrefsApi]);

  const updatedColumns = columns.map((col: any, index: any) => ({
    ...col,
    title: (
      <div className="resizable-header">
        {col.title}
        <div
          className="resizer"
          onMouseDown={(e) => handleMouseDown(e, index)}
        />
      </div>
    ),
  }));

  return (
    <div className="admin-cases">
      <AppCard>
        <Row>
          <Col span={12}>
            <h2 className="mt-2">Cases</h2>
          </Col>
        </Row>
        <CaseFilterForm
          isAdmin
          formValues={formValues}
          onReset={handleResetFilters}
          onSync={handleFetchCases}
          loading={isSyncing}
          onListingColumnsSaved={() => {
            ListingColumnPreferenceService.fetch(
              UserRoleEnum.ADMIN,
              LISTING_CONTEXT.ADMIN_CASES,
              (data) => setListingPrefsApi(data),
              () => setListingPrefsApi(null),
              () => {}
            );
          }}
        />
        <>
          {
            loading ? <AppLoader loading={loading} /> : 
            (
              <Table
                dataSource={caseDetails}
                rowKey={(record) => record.id ?? 0}
                scroll={{ x: "max-content", y: `calc(100vh - 375px)` }}
                rowClassName={caseListRowClassName}
                onRow={handleRowChange}
                columns={updatedColumns}
                expandable={{
                  expandedRowRender: (record) => (
                    <CaseSeriesExpandRow
                      caseDetailId={record.id!}
                      fetchThumbnails={AdminCaseService.showAdminCaseDirectories}
                      fetchDicomFiles={AdminCaseService.showAdminCaseDirectoryFiles}
                      onSeriesOpen={handleSeriesOpen}
                    />
                  ),
                  rowExpandable: (record) => record.id != null,
                }}
                pagination={{
                  current: paginationMeta?.currentPage,
                  pageSize: paginationMeta?.perPage,
                  total: paginationMeta?.totalCount,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "15", "20", "50"],
                }}
                onChange={handlePageChange}
              />
            )
          }
        </>
        {caseDetails.length > 0 && <TagLegend />}
      </AppCard>
      <ContextMenu
        visible={menuVisible}
        position={menuPosition}
        selectedRow={selectedRow}
        onClose={() => setMenuVisible(false)}
        onUpdate={handleUpdateTags}
      />
      <CaseChatDrawer
        open={caseChat !== null}
        onClose={() => {
          setCaseChatDrawerCaseId(null);
          setCaseChat(null);
        }}
        caseDetailId={caseChat?.id ?? null}
        title={caseChat?.title}
        userRole={UserRoleEnum.ADMIN}
        currentUserId={me?.id}
      />
      <Modal
        destroyOnClose
        visible={showCaseOverview}
        className="primary-modal"
        onCancel={handleCloseCaseOverview}
        footer={null}
        maskClosable={false}
      >
        {activeCase?.id && (
          <CaseOverview
            isAdmin
            activeCaseId={activeCase?.id}
            onCancel={handleCloseCaseOverview}
            onUpdateSuccess={handleCaseUpdateSuccess}
          />
        )}
      </Modal>
      <Modal
        destroyOnClose
        visible={showCaseForm}
        className="primary-modal"
        onCancel={handleToggleCaseForm}
        footer={null}
        maskClosable={false}
      >
        {activeCase && (
          <CaseForm
            caseDetailId={activeCase?.id}
            onSuccess={handleUploadCaseSuccess}
            onClose={() => setShowCaseForm(false)}
          />
        )}
      </Modal>
      <Modal
        destroyOnClose
        visible={showReportHistory}
        onCancel={handleToggleReportHistory}
        footer={null}
        maskClosable={false}
        className="primary-modal"
      >
        <ReportHistory caseDetail={activeCase} />
      </Modal>
      <CaseTurnaroundTime
        visible={showTATModal}
        data={tatData}
        onClose={() => {
          setShowTATModal(false);
          setTatData(null);
          setActiveCase(undefined);
        }}
      />
      <Drawer
        destroyOnClose
        title={null}
        className="admin-cases__generate-report-drawer"
        width="80%"
        onClose={handleToggleReportForm}
        visible={showReportForm}
        maskClosable={false}
        footer={null}
        keyboard={false}
      >
        {activeCase?.id && (
          <ReportForm
            onClose={handleToggleReportForm}
            caseDetailId={activeCase.id}
            onPublish={() => handleFetchCases(formValues)}
          />
        )}
      </Drawer>
    </div>
  );
}

export default CaseContainer(ReportLockContainer(AdminCases));
